import cn from 'classnames';
import I18n from 'hooks/useI18n';
import { Component } from 'react';
import Modal from 'react-modal';

import MemberButton from 'components/common/buttons/MemberButton';
import Loading from 'components/common/loaders/Loader';
import MessengersInboxHeaderDesktop from '../../MessengerInbox/MessengerInboxHeader/MessengerInboxHeaderDesktop';

import { CUSTOM_EVENT_MODAL, PARAMS_MODAL } from 'redhotpie-shared-lib/constants/constants';
import { PROSPECT, ROOT_FOLDER } from 'redhotpie-shared-lib/constants/routes';
import * as storage from 'redhotpie-shared-lib/functions/localStorage';
import { phoneDetect } from 'redhotpie-shared-lib/functions/utils';
import { icCloseMemberModal, icCloseModal } from 'redhotpie-shared-lib/themes/ImagesSVG';

import Img from 'components/common/Img';
import { stopEvent } from 'functions/webUtils';
import { CALL_STATE, WINDOW_CALL_TYPE } from 'redhotpie-shared-lib/constants/constants';
import { CHAT_ROOMS } from 'redhotpie-shared-lib/constants/routes';
import { detectIos } from 'redhotpie-shared-lib/functions/utils';
import { IParams } from 'redhotpie-shared-lib/interfaces/IAction';
import { getStore } from 'redhotpie-shared-lib/store/myStore';
import './style.scss';

const SWIPE_THRESHOLD = 70;

export interface IModalComponentProps {
  modalName?: string;
  showModal: boolean;
  modalClass?: string;
  customModalClass?: string;
  customContainerClassName?: string;
  customOverlayClassName?: string;
  isBottomModal?: boolean;
  isBrowserModal?: boolean;
  fullScreen?: boolean;
  isShowCloseInside?: boolean;
  isOverlayBlack?: boolean;
  isOverlayGray?: boolean;
  autoResizeHeight?: boolean;
  disableClickOverlay?: boolean;
  disableEscClose?: boolean;
  zIndexModal?: number;
  onClose?: (extraParam?: any) => void;
  resetState?: () => void;
  headerText?: string;
  isRenderCustomBodyContainer?: boolean;
  isSubModal?: boolean;
  pullDownToClose?: boolean;
  wrapperPosition?: number;
  isScrollInside?: boolean;
  widthMax?: number;
  isDisableOkButton?: boolean;
  noPadding?: boolean;
  history?: any;
  location?: any;
  [key: string]: any; // For other props
}

interface ModalComponentState {
  isDrag: boolean;
  y: number;
  clientHeight: number;
  indexContent: number;
  startY: number;
  translateY: number;
  isSwiping: boolean;
}

let progressBackUrl = false;
let progressCloseModal = false;
let stackModalName: string[] = [];
let timeInterval: NodeJS.Timeout | string | number | undefined = undefined;

function generateNewIdentifyKey() {
  return `__${Math.random().toString(36).substring(5)}`;
}

export default class ModalComponent extends Component<IModalComponentProps, ModalComponentState> {
  private extraParam: any;
  private isMobile: boolean | string;
  private showModal: boolean | string;
  private keyIdentify: string;
  private checkInitUrl: boolean;
  private modalMain: any;

  constructor(props: IModalComponentProps) {
    super(props);
    this.state = {
      isDrag: false,
      y: 0,
      clientHeight: 0,
      indexContent: -1,
      startY: 0,
      translateY: 0,
      isSwiping: false,
    };

    this.extraParam = null;
    this.isMobile = phoneDetect();
    this.showModal = '';
    this.checkInitUrl = false;
    this.keyIdentify = '';

    this.onPopState = this.onPopState.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.checkWrapper = this.checkWrapper.bind(this);
    this.customEventModal = this.customEventModal.bind(this);
  }

  componentWillMount() {
    Modal.setAppElement('body');
  }

  componentDidMount() {
    this.keyIdentify = generateNewIdentifyKey();
    window.addEventListener('popstate', this.onPopState, false);
    window.addEventListener(CUSTOM_EVENT_MODAL, this.customEventModal);
  }

  componentDidUpdate(prevProps: IModalComponentProps, prevS: ModalComponentState) {
    const modalName = this.props.modalName || this.constructor.name;
    if (
      this.isMobile &&
      (this.props.showModal !== prevProps.showModal || (this.props.showModal && !this.checkInitUrl)) &&
      this.props.showModal &&
      !this.showModal &&
      // eslint-disable-next-line no-restricted-globals
      location.href.indexOf(modalName + this.keyIdentify) === -1
    ) {
      this.showModal = modalName + this.keyIdentify;
      this.checkInitUrl = true;

      if (
        this.props.location &&
        this.props.history &&
        !this.props.disableBackCloseModal &&
        !this.props.disableBackBrowserCloseModal &&
        !this.isChatRoomPage()
      ) {
        let search = '';
        if (this.props.location.search && this.props.location.search.indexOf('?') !== -1) {
          search = `${this.props.location.search}&${PARAMS_MODAL}=${modalName + this.keyIdentify}`;
        } else {
          search = `?${PARAMS_MODAL}=${modalName + this.keyIdentify}`;
        }
        stackModalName.push(modalName + this.keyIdentify);
        stackModalName = stackModalName.filter(modalName => search.indexOf(modalName) !== -1);
        this.props.history.push(window.location.pathname + search);
      } else {
        console.warn('Please add prop HISTORY to this modal: ', modalName);
        this.showModal = false;
        this.checkInitUrl = false;
      }
    }

    if (this.props.triggerShouldCallClose && !prevProps.triggerShouldCallClose) {
      this.closeModal();
    }

    if (this.props.showModal !== prevProps.showModal && this.props.isBottomModal) {
      if (this.props.showModal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      // if (this.props.pullDownToClose && detectIos()) { // enable this when we have issue with pull to refresh on ios
      //   // disable pull to refresh on ios
      //   if (this.props.showModal) {
      //     document.body.style.overscrollBehavior = 'none';
      //     document.documentElement.style.overscrollBehavior = 'none';
      //   } else {
      //     document.body.style.overscrollBehavior = 'auto';
      //     document.documentElement.style.overscrollBehavior = 'auto';
      //   }
      // }
    }
  }

  componentWillUnmount() {
    // const { modalMain } = this;
    // if (modalMain) {
    //   modalMain.node.removeEventListener('touchstart', this.onDragStart, {
    //     capture: true,
    //   });
    //   modalMain.node.removeEventListener('touchmove', this.onDragMove, {
    //     capture: true,
    //   });
    //   modalMain.node.removeEventListener('touchend', this.onDragEnd, {
    //     capture: true,
    //   });
    // }

    window.removeEventListener('popstate', this.onPopState, false);
    window.removeEventListener(CUSTOM_EVENT_MODAL, this.customEventModal);
  }

  isChatRoomPage() {
    const isChatRoom = window.location.pathname === `${ROOT_FOLDER}/${CHAT_ROOMS}`;
    const isIOS = detectIos();
    const { videoCallReducer } = getStore().getState();
    const isCalling = videoCallReducer.callState !== CALL_STATE.IDLE && videoCallReducer.windowCallType !== WINDOW_CALL_TYPE.NONE;

    return isIOS && (isChatRoom || isCalling);
  }

  // handle close modal when click back on browser or android device
  onPopState() {
    if (!this.isMobile) {
      return;
    }
    const modalName = this.props.modalName || this.constructor.name;
    progressCloseModal = false;
    if (this.props.disableBackCloseModal || this.props.disableBackBrowserCloseModal) {
      return;
    }
    if (stackModalName.indexOf(modalName + this.keyIdentify) !== stackModalName.length - 1 || stackModalName.length === 0) {
      return;
    }
    if (progressBackUrl) {
      return;
    }
    if (this.isMobile) {
      progressBackUrl = true;
    }
    if (modalName + this.keyIdentify === stackModalName[stackModalName.length - 1] && this.props.onClose) {
      this.checkWrapper();
      this.showModal = false;
      // eslint-disable-next-line no-restricted-globals
      stackModalName = stackModalName.filter(modalName => location.href.indexOf(modalName) !== -1);
      this.props.onClose(this.extraParam);
      this.extraParam = null;
      this.keyIdentify = generateNewIdentifyKey();
    }
    setTimeout(() => {
      progressBackUrl = false;
    }, 50);
  }

  handleTouchStart = (event: any) => {
    if (this.props.isBottomModal) {
      this.setState({ startY: event.touches[0].clientY, isSwiping: true });
    }
  };

  handleTouchMove = (event: any) => {
    // stopEvent(event);
    if (this.props.isBottomModal) {
      const { startY, isSwiping } = this.state;
      if (!isSwiping) return;

      const currentY = event.touches[0].clientY;
      const deltaY = startY - currentY;
      this.setState({ translateY: Math.min(deltaY, 0) });
    }
  };

  handleTouchEnd = () => {
    if (this.props.isBottomModal) {
      const { translateY } = this.state;
      if (translateY < -SWIPE_THRESHOLD) {
        this.closeModal();
      } else {
        this.setState({ translateY: 0 });
      }

      this.setState({ isSwiping: false });
    }
  };

  onDragStart(e: any) {
    const { path } = e;
    if (!('path' in Event.prototype)) {
      Object.defineProperty(Event.prototype, 'path', {
        get() {
          const path = [];
          let currentElem = this.target;
          while (currentElem) {
            path.push(currentElem);
            currentElem = currentElem.parentElement;
          }
          if (path.indexOf(window) === -1 && path.indexOf(document) === -1) {
            path.push(document);
          }
          if (path.indexOf(window) === -1) {
            path.push(window);
          }
          return path;
        },
      });
    }
    const indexContent = path
      ? path.findIndex((itm: any) => itm.classList !== undefined && itm.classList[0] === 'ReactModal__Content')
      : -1;
    const heightBody = document.body.clientHeight;
    if (indexContent !== -1) {
      const modalContent = path[indexContent];
      const heightContent = modalContent.clientHeight;
      const heightOverlay = heightBody - heightContent;

      if (!this.state.isDrag && e.changedTouches[0].pageY > heightOverlay - 50 && e.changedTouches[0].pageY < heightOverlay + 50) {
        modalContent.classList.remove('animated', 'fadeInUp');
        this.setState({
          isDrag: true,
          y: e?.changedTouches[0]?.pageY || 0,
          clientHeight: modalContent?.clientHeight || 0,
          indexContent,
        });
      } else if (this.state.isDrag) {
        this.setState({
          isDrag: false,
        });
      }
    }
  }

  onDragMove(e: any) {
    const { y, indexContent } = this.state;
    const { path, changedTouches } = e;
    if (this.state.isDrag && changedTouches[0].pageY >= y && indexContent !== -1) {
      stopEvent(e);
      const modalContent = path[indexContent];
      const transY = changedTouches[0].pageY - y;

      modalContent.style.transform = `translateY(${transY}px)`;
      modalContent.style.transitionDuration = '';
    }
  }

  onDragEnd(e: any) {
    const { y, indexContent } = this.state;
    const { path, changedTouches } = e;
    if (this.state.isDrag && indexContent !== -1) {
      const calTranY = this.calculaterTransY(y, changedTouches[0].pageY);
      const modalContent = path[indexContent];
      if (calTranY >= 50 && y < changedTouches[0].pageY) {
        modalContent.style.transform = 'translateY(150%)';
        modalContent.style.transitionDuration = '250ms';

        setTimeout(() => {
          this.closeModal();
        }, 50);
      } else {
        modalContent.style.transform = 'translateY(0)';
        modalContent.style.transitionDuration = '250ms';
      }

      this.setState({
        isDrag: false,
      });
    }
  }

  // handle CUSTOM_EVENT_MODAL
  customEventModal(e: any) {
    this.closeModal(e.detail.callback);
  }

  checkWrapper() {
    const { memberSearchReducer, memberProspectsReducer } = this.props;
    const isCarouselView = memberSearchReducer && memberSearchReducer.filters.isCarouselView === 'true';
    const isProspectCarouselView = storage.get('isCarousel');
    if (!this.props.isSubModal) {
      const wrapperMobile = document.getElementById('wrapper-mobile');
      if (wrapperMobile && !isCarouselView) {
        wrapperMobile.style.overflow = '';
        wrapperMobile.style.position = '';
        wrapperMobile.style.top = '';
        window.scrollTo(0, memberSearchReducer ? memberSearchReducer.positionGoto : 0);
      }

      if (window.location.pathname === `${ROOT_FOLDER}/${PROSPECT}` && wrapperMobile && isProspectCarouselView === 'false') {
        wrapperMobile.style.overflow = '';
        wrapperMobile.style.position = '';
        wrapperMobile.style.top = '';
        window.scrollTo(0, memberProspectsReducer ? memberProspectsReducer.positionGoto : 0);
      }
      if (wrapperMobile && this.props.wrapperPosition && this.props.wrapperPosition !== 0) {
        wrapperMobile.scrollTop = this.props.wrapperPosition;
        window.scrollTo(0, this.props.wrapperPosition);
      }
    }
  }

  /**
   * Close modal function
   * Should call this when you close modal
   * @param cb
   * @param extraParam: {}
   */
  closeModal(cb?: (extraParam?: any) => void, extraParam?: any) {
    this.setState({ isSwiping: false, translateY: 0, startY: 0 }); // Reset state after closing
    this.extraParam = extraParam;
    if (progressBackUrl) {
      // Reject close modal when back url till processing
      console.warn('Reject close modal when back url till processing');
      return;
    }
    if (progressCloseModal) {
      // Reject close modal when back url till processing
      console.warn('Reject close modal when handle close modal function');
      return;
    }
    if (this.isMobile) {
      progressCloseModal = true;
    }

    this.checkWrapper();
    if (this.props.onClose) {
      // console.log("closeModal ", this.showModal);
      // modalNameClose = stackModalName.pop();
      // stackModalName = stackModalName.filter(modalName => location.href.indexOf(modalName) !== -1);
      // console.log("closeModal: stackModalName: ", stackModalName);
      if (!this.isMobile) {
        this.props.onClose(extraParam);
        this.extraParam = null;
      } else {
        if (!this.props.disableBackCloseModal) {
          if (this.props.disableBackBrowserCloseModal || !this.props.history || this.isChatRoomPage()) {
            // We do not handle back here, so set progressCloseModal = false
            progressCloseModal = false;
            this.props.onClose(extraParam);
            this.extraParam = null;
          } else {
            const modalName = this.props.modalName || this.constructor.name;
            // case force close modal without url check
            if (!window.location.search.includes(modalName + this.keyIdentify)) {
              this.showModal = false;
              stackModalName = stackModalName.filter(modalName => window.location.href.indexOf(modalName + this.keyIdentify) !== -1);
              this.props.onClose(this.extraParam || cb);
              this.extraParam = null;
              progressCloseModal = false;
            } else {
              this.props.history.goBack();
            }
          }
        }
      }
    }

    if (!this.props.disableBackCloseModal) {
      // handle callback here to check when history back is done
      if (timeInterval) {
        clearInterval(timeInterval);
      }
      timeInterval = setInterval(() => {
        if (!progressBackUrl) {
          clearInterval(timeInterval);
          // console.warn('progress back url is done, modalName is: ', modalName + this.keyIdentify);
          if (typeof cb === 'function') {
            cb(extraParam);
            this.extraParam = null;
          }
        }
      }, 100);
    } else {
      progressCloseModal = false;
    }
  }

  calculaterTransY(oldY: number, newY: number) {
    const { clientHeight } = this.state;
    const a = clientHeight - oldY;
    const b = clientHeight - newY;

    return Math.abs(100 - Math.round((b * 100) / a));
  }

  afterOpenModal() {
    const {
      isScroll,
      handleScroll,
      onShowTabMenu,
      isBottomModal,
      memberSearchReducer,
      memberProspectsReducer,
      onCallbackAfterOpen,
      isOptionModal,
    } = this.props;
    // document.body.style.overflow = 'hidden';
    if (isScroll) {
      const contentModal = document.getElementsByClassName('ReactModal__Content')[0];
      contentModal.addEventListener('scroll', handleScroll);
    }

    const wrapperMobile = document.getElementById('wrapper-mobile');
    const myDate = document.getElementById('my-date-finder');

    if (wrapperMobile !== null) {
      // if (this.props.isConversationModal) {
      wrapperMobile.style.overflow = 'hidden';
      wrapperMobile.style.position = myDate ? 'fixed' : 'relative';

      if (window.location.pathname === `${ROOT_FOLDER}/${PROSPECT}`) {
        wrapperMobile.scrollTop = memberProspectsReducer ? memberProspectsReducer.positionGoto : 0;
      } else {
        wrapperMobile.scrollTop = memberSearchReducer ? memberSearchReducer.positionGoto : 0;
      }
      if (this.props.wrapperPosition && this.props.wrapperPosition !== 0) {
        wrapperMobile.scrollTop = this.props.wrapperPosition;
        window.scrollTo(0, this.props.wrapperPosition);

        if (myDate) {
          wrapperMobile.style.top = `-${this.props.wrapperPosition}px`;
        }
      }
      // }
    }
    if (onShowTabMenu) {
      onShowTabMenu(true);
    }

    // if (isBottomModal && !isOptionModal) {
    //   const { modalMain } = this;
    //   if (modalMain !== null) {
    //     modalMain.node.addEventListener('touchstart', (e: any) => this.onDragStart(e), { capture: true });
    //     modalMain.node.addEventListener('touchmove', (e: any) => this.onDragMove(e), { capture: true });
    //     modalMain.node.addEventListener('touchend', (e: any) => this.onDragEnd(e), {
    //       capture: true,
    //     });
    //   }
    // }

    if (onCallbackAfterOpen && typeof onCallbackAfterOpen === 'function') {
      onCallbackAfterOpen();
    }
  }

  render(children?: any, childrenContainerCustom?: any, otherProps: IParams = {}) {
    const {
      isLoading,
      isNotificationModal,
      isRenderCustomBodyContainer,
      isBottomModal,
      showModal,
      modalClass = '',
      customModalClass = '',
      isAddAnimationUpDown,
      headerText,
      allowShowHeaderTextEmpty,
      subHeaderText,
      okText,
      okBtnClassName,
      cancelText,
      cancelBtnClassName,
      actionWrapperClass,
      customActionWrapperClassName,
      onCancelClick,
      onActionClick,
      isDisableOkButton,
      customActionFooter,
      customOverlayClassName = '',
      customContainerClassName = '',
      isOptionModal,
      zIndexModal = 10,
      isImageGalleryMobile = false,
      noAnimated,
      disableClickOverlay,
      disableEscClose,
      widthMax,
      heightMax,
      contentHeader,
      btnActionOutline,
      childHook,
      idModal,
      isOverlayGray = false,
      fullScreen = false,
      isBrowserModal = false,
      isShowCloseInside = false,
      isOverlayBlack = false,
      disableBackCloseModal = false,
      isNoShowIconClose = false,
      autoResizeHeight = false,
      customIconCloseModal,
      customIconCloseAction,
      pullDownToClose = false,
      isScrollInside = false,
      noPadding = false,
    } = this.props;
    const customCancelText = otherProps.cancelText ? otherProps.cancelText : cancelText;
    const customOkText = otherProps.okText ? otherProps.okText : okText;
    const { translateY } = this.state;
    const customClassModal = cn({
      animated: !noAnimated,
      [`fadeIn${isBottomModal || isAddAnimationUpDown || fullScreen ? 'Up' : ''}`]: showModal && !isImageGalleryMobile,
      [`fadeOut${isBottomModal || isAddAnimationUpDown || fullScreen ? 'Down' : ''}`]: !showModal && !isImageGalleryMobile,
      'modal-center-wrapper': !isBottomModal && !customModalClass && !fullScreen,
      'modal-bottom-wrapper': isBottomModal && !customModalClass && !isBrowserModal,
      'modal-browser-wrapper': isBrowserModal,
      'modal-full-screen-wrapper': !isBrowserModal && fullScreen,
      [customModalClass]: customModalClass,
      [modalClass]: modalClass,
      [`width-max${widthMax}`]: widthMax,
      [`height-max${heightMax}`]: heightMax,
      '-modal-wrapper-mobile': this.isMobile,
      'modal-full-height-scroll-inside': isScrollInside && !pullDownToClose,
    });

    const customActionWrapperClass =
      customActionWrapperClassName ||
      cn('__button-group floating-bottom', {
        // "button-only-wrapper": !customCancelText || !customOkText,
        [actionWrapperClass]: actionWrapperClass,
      });
    const customCancelBtnClass = cn('cancel-button', {
      [cancelBtnClassName]: cancelBtnClassName,
    });
    const customOKBtnClass = cn('ok-button', {
      [okBtnClassName]: okBtnClassName,
      '--fade-input': otherProps.fadeInput,
      disabled: isDisableOkButton,
    });
    const onRequestCloseModal = () => {
      if (otherProps.onCancelClick && !otherProps.ignoreClickOverlay) {
        otherProps.onCancelClick();
      }
      this.closeModal();
    };
    const zIndexModalClass = zIndexModal && zIndexModal > 0 && zIndexModal < 101 ? `z-index-modal-${zIndexModal}` : '';
    const customOverlayClass = cn({
      'modal-overlay': !customOverlayClassName,
      [customOverlayClassName]: customOverlayClassName,
      [zIndexModalClass]: zIndexModalClass,
      'modal-overlay-mobile': (this.isMobile && isBottomModal && !isOptionModal) || isOverlayBlack,
      'overlay-gray': isOverlayGray,
    });
    const customClassModalContainer = cn({
      'modal-container': !fullScreen && !isShowCloseInside,
      'modal-body-full-screen': fullScreen,
      'modal-desktop-wrapper': isShowCloseInside,
      [customContainerClassName]: customContainerClassName,
      '-modal-container-mobile': this.isMobile,
      'modal-height-resize': autoResizeHeight,
    });
    const onClickIconClose = () => {
      this.closeModal();
      if (otherProps.resetState) {
        otherProps.resetState();
      }
    };

    if (!showModal) return null;

    let contentModal = (
      <>
        {isRenderCustomBodyContainer && isLoading && (
          <div className="__modal-body">
            <Loading msg={I18n.t('PleaseWait')} />
          </div>
        )}
        {isRenderCustomBodyContainer && typeof childrenContainerCustom === 'function' && childrenContainerCustom()}
        {isRenderCustomBodyContainer && typeof childrenContainerCustom !== 'function' && childrenContainerCustom}
        {isRenderCustomBodyContainer && typeof childHook === 'function' && childHook()}
        {isRenderCustomBodyContainer && this.props.children}
        {!isRenderCustomBodyContainer && (
          <div className={isOptionModal ? '' : customClassModalContainer}>
            {contentHeader}
            {isBottomModal && !isOptionModal && (
              <div className="icon-closeX" id="divBar" onClick={() => this.closeModal()}>
                <span>Close X</span>
              </div>
            )}
            {!isShowCloseInside && !isNotificationModal && !subHeaderText && headerText && !pullDownToClose && (
              <div className="__header-text">{headerText}</div>
            )}
            {!isShowCloseInside && !isNotificationModal && subHeaderText && (
              <div className="__header-text --has-sub-text">{headerText}</div>
            )}
            {!isShowCloseInside && !isNotificationModal && subHeaderText && <div className="__sub-header-text">{subHeaderText}</div>}
            {!isShowCloseInside && !isBottomModal && !isNotificationModal && !fullScreen && (
              <div className="__icon-close" onClick={onClickIconClose}>
                <Img src={icCloseMemberModal} alt="close-member-modal" />
              </div>
            )}
            {isShowCloseInside && (headerText || allowShowHeaderTextEmpty) && !this.props.disableIconClose && (
              <MessengersInboxHeaderDesktop
                title={headerText}
                onClickRightButton={onClickIconClose}
                disableIconClose={this.props.disableIconClose}
                className={!headerText && allowShowHeaderTextEmpty ? 'header-empty-text' : ''}
              />
            )}
            {fullScreen && !isNoShowIconClose && (
              <div className="__action-close-on-mobile">
                <Img
                  src={customIconCloseModal || icCloseModal}
                  alt="close-modal"
                  onClick={() => {
                    if (typeof customIconCloseAction === 'function') {
                      customIconCloseAction();
                    } else {
                      this.closeModal();
                    }
                  }}
                />
              </div>
            )}
            {childrenContainerCustom && childrenContainerCustom()}
            {childHook && childHook()}
            {!childrenContainerCustom && !childHook && (
              <div className="__modal-body">
                {this.props.showLoading && <Loading msg={I18n.t('PleaseWait')} />}
                {typeof children === 'function' && children()}
                {this.props.children}
              </div>
            )}

            {customActionFooter && customActionFooter}

            {(customOkText || customCancelText) && (
              <div className={customActionWrapperClass}>
                {customCancelText && (
                  <MemberButton
                    text={customCancelText}
                    className={customCancelBtnClass}
                    onClick={otherProps.onCancelClick ? otherProps.onCancelClick : onCancelClick}
                  />
                )}

                {customOkText && (
                  <MemberButton
                    text={customOkText}
                    className={customOKBtnClass}
                    onClick={otherProps.onActionClick ? otherProps.onActionClick : onActionClick}
                    color={btnActionOutline ? 'outlineGray' : 'primary'}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </>
    );
    if (isBottomModal && pullDownToClose) {
      contentModal = (
        <div
          style={{ transform: `translateY(${-translateY}px)` }}
          className={cn('wrapper-content-button-modal', { 'padding-0': noPadding })}>
          <div
            className="wrapper-content-button-modal__drag-indicator"
            onTouchStart={this.handleTouchStart}
            onTouchMove={this.handleTouchMove}
            onTouchEnd={this.handleTouchEnd}>
            <div />
          </div>
          {headerText && <div className="wrapper-content-button-modal__header-text">{headerText}</div>}
          <div className={cn('scroll-able-y', { 'scroll-inside': isScrollInside })}>{contentModal}</div>
          {(customCancelText || customOkText) && !pullDownToClose && (
            <div className={customActionWrapperClass}>
              {customCancelText && (
                <MemberButton
                  text={customCancelText}
                  className={customCancelBtnClass}
                  onClick={otherProps.onCancelClick ? otherProps.onCancelClick : onCancelClick}
                />
              )}

              {customOkText && (
                <MemberButton
                  text={customOkText}
                  className={customOKBtnClass}
                  onClick={otherProps.onActionClick ? otherProps.onActionClick : onActionClick}
                  color={btnActionOutline ? 'outlineGray' : 'primary'}
                />
              )}
            </div>
          )}
        </div>
      );
    }

    return (
      <Modal
        isOpen={showModal}
        className={customClassModal}
        onAfterOpen={this.afterOpenModal}
        overlayClassName={customOverlayClass}
        onRequestClose={onRequestCloseModal}
        shouldCloseOnOverlayClick={!disableClickOverlay}
        shouldCloseOnEsc={!disableEscClose}
        closeTimeoutMS={300}
        bodyOpenClassName="ReactModal_Open"
        ref={elm => {
          this.modalMain = elm;
        }}
        id={idModal || 'modal-default'}>
        {contentModal}
      </Modal>
    );
  }
}
